import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';

export const embedValidator = new ValidatorHelper({
  embedWidgetName: {
    rules: 'required',
    pretty: 'name'
  },
  embedBgColor: {
    rules: 'required|hex',
    pretty: 'background color'
  },
  embedButtonColor: {
    rules: 'required|hex',
    pretty: 'button color'
  },
  embedAccentColor: {
    rules: 'required|hex',
    pretty: 'accent color'
  },
  embedLogoUrl: {
    rules: 'url:{true}',
    pretty: 'logo URL'
  }
});

export const infoValidator = new ValidatorHelper({
  name: {
    rules: 'required|min:4|max:80',
    pretty: 'campaign title',
  },
  description: {
    rules: 'required|min:3|max:2000',
    pretty: 'campaign description',
  }
});

export const productValidator = {};

export const seoValidator = new ValidatorHelper({
  'viralstyle.title': {
    rules: 'max:100',
    pretty: 'title',
  },
  'viralstyle.keywords': {
    rules: 'max:250',
    pretty: 'keywords',
  },
  'viralstyle.description': {
    rules: 'max:250',
    pretty: 'description',
  },
  'open_graph.title': {
    rules: 'max:100',
    pretty: 'title',
  },
  'open_graph.description': {
    rules: 'max:250',
    pretty: 'description',
  },
  'twitter.title': {
    rules: 'max:100',
    pretty: 'title',
  },
  'twitter.description': {
    rules: 'max:250',
    pretty: 'description',
  },
});

export const urlBuilderValidator = new ValidatorHelper({
  title: {
    rules: 'max:255',
    pretty: 'title',
  },
  utm_source: {
    rules: 'max:255',
    pretty: 'source',
  },
  utm_campaign: {
    rules: 'max:255',
    pretty: 'campaign',
  },
  utm_medium: {
    rules: 'max:255',
    pretty: 'medium',
  },
  utm_term: {
    rules: 'max:255',
    pretty: 'term',
  },
  utm_content: {
    rules: 'max:255',
    pretty: 'content',
  },
});